export default __webpack_public_path__ + "static/media/ruby-on-rails.94f31c75.svg";